// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main{

}

.styles_container__WlZGF{
	width: var(--container-width-md);
	margin: 80px auto 30px auto ;
	
}

.styles_container__WlZGF > div > h1{
	font-style: normal;
	font-weight: 420;
	font-size: 40px;
	line-height: 57px;
	text-align: center;
}

.styles_section__dA-UT{
	width: 90%;
	margin: 64px auto 0 auto;
}

.styles_section__dA-UT > img {
	float: right;
	width: 263px;
	height: 283px;
	margin-left: 10px;
}

.styles_listWithout__AsSAm > ul{
	font-style: normal;
	font-weight: 390;
	font-size: 22px;
	line-height: 31px;
	list-style: none;

}

.styles_listWithout__AsSAm > ul >li{
	margin-top: 15px;
}

.styles_listWith__RNu3b{
	padding-left: 20px;
}

.styles_listWith__RNu3b > ul{
	font-style: normal;
	font-weight: 390;
	font-size: 22px;
	line-height: 31px;
	padding-left: 20px;


}


.styles_section__dA-UT > ul {
	list-style: none;
	margin-left: 0;
	margin-top: 15px;
	font-style: normal;
	font-weight: 390;
	font-size: 22px;
	line-height: 31px;
}


@media screen and (max-width: 820px ) {
	.styles_section__dA-UT{
		width: clamp(337px,10vw,738px);
		display: flex;
		flex-direction: column;
		row-gap: 10px;
	}
	.styles_section__dA-UT > img {
		float: none;
		margin: auto;
	}

	.styles_section__dA-UT > ul >li {
	
		font-size: clamp(18px,6vw,22px);

	}
}`, "",{"version":3,"sources":["webpack://./src/pages/HowAlinWorksPage/styles.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;;AAE7B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;;AAEjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;;;AAGnB;;;AAGA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;;AAGA;CACC;EACC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,aAAa;CACd;CACA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;;EAEC,+BAA+B;;CAEhC;AACD","sourcesContent":["main{\n\n}\n\n.container{\n\twidth: var(--container-width-md);\n\tmargin: 80px auto 30px auto ;\n\t\n}\n\n.container > div > h1{\n\tfont-style: normal;\n\tfont-weight: 420;\n\tfont-size: 40px;\n\tline-height: 57px;\n\ttext-align: center;\n}\n\n.section{\n\twidth: 90%;\n\tmargin: 64px auto 0 auto;\n}\n\n.section > img {\n\tfloat: right;\n\twidth: 263px;\n\theight: 283px;\n\tmargin-left: 10px;\n}\n\n.listWithout > ul{\n\tfont-style: normal;\n\tfont-weight: 390;\n\tfont-size: 22px;\n\tline-height: 31px;\n\tlist-style: none;\n\n}\n\n.listWithout > ul >li{\n\tmargin-top: 15px;\n}\n\n.listWith{\n\tpadding-left: 20px;\n}\n\n.listWith > ul{\n\tfont-style: normal;\n\tfont-weight: 390;\n\tfont-size: 22px;\n\tline-height: 31px;\n\tpadding-left: 20px;\n\n\n}\n\n\n.section > ul {\n\tlist-style: none;\n\tmargin-left: 0;\n\tmargin-top: 15px;\n\tfont-style: normal;\n\tfont-weight: 390;\n\tfont-size: 22px;\n\tline-height: 31px;\n}\n\n\n@media screen and (max-width: 820px ) {\n\t.section{\n\t\twidth: clamp(337px,10vw,738px);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\trow-gap: 10px;\n\t}\n\t.section > img {\n\t\tfloat: none;\n\t\tmargin: auto;\n\t}\n\n\t.section > ul >li {\n\t\n\t\tfont-size: clamp(18px,6vw,22px);\n\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__WlZGF`,
	"section": `styles_section__dA-UT`,
	"listWithout": `styles_listWithout__AsSAm`,
	"listWith": `styles_listWith__RNu3b`
};
export default ___CSS_LOADER_EXPORT___;
